/* eslint-disable max-len */
import env from '../config/env';
import ApiService from './ApiService';

const createCarrierProspect = (data) => ApiService.httpClient.post(`${env.api.url}/v0/carrier-prospects/prospect`, data);

const updateCompanyDataProspect = (uuid, data) => ApiService.httpClient.put(`${env.api.url}/v0/carrier-prospects/prospect/${uuid}/fill-company`, data);

const CarrierProspectService = {
  createCarrierProspect,
  updateCompanyDataProspect,
};

export default CarrierProspectService;
